module.exports = __webpack_public_path__ + "static/img/wd5.656d540.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/workimg/wd5.png
// module id = gj5K
// module chunks = 10